import { useNavigate } from 'react-router';
import { Home, ArrowLeft } from 'lucide-react';
import { useTranslation } from '../i18n';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-gradient-to-br from-vivatis-50 via-white to-vivatis-100">
      {/* Decorative background shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full blur-3xl bg-vivatis-200/40" />
        <div className="absolute -bottom-32 -left-32 w-[30rem] h-[30rem] rounded-full blur-3xl bg-vivatis-300/30" />
      </div>

      <div className="relative text-center">
        {/* Large 404 */}
        <h1 className="text-[10rem] font-heading font-bold leading-none text-vivatis-400/30 select-none">
          {t.notFound.title}
        </h1>

        {/* Message */}
        <div className="-mt-8">
          <h2 className="text-2xl font-heading font-semibold text-anthracite-500 mb-2">
            {t.notFound.heading}
          </h2>
          <p className="text-gray-500 max-w-md mx-auto">
            {t.notFound.description}
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-center gap-3 mt-8">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <ArrowLeft size={16} />
            {t.notFound.goBack}
          </button>
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium rounded-lg bg-vivatis-600 text-white hover:bg-vivatis-700 transition-colors cursor-pointer"
          >
            <Home size={16} />
            {t.notFound.home}
          </button>
        </div>
      </div>

      {/* Footer */}
      <p className="relative mt-16 text-xs text-gray-400">
        {t.brand.copyright}
      </p>
    </div>
  );
};

export default NotFoundPage;
